import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/fontawesome-free-solid'

class StarRating extends PureComponent {
  handleClick (value) {
    if (this.props.editable && this.props.onChange) {
      this.props.onChange(value)
    }
  }

  render () {
    const { value, max, editable, showLabel, label, size } = this.props
    const stars = []
    for (let i = 1; i <= max; i++) {
      // Fractional fill: 1 = full, 0 = empty, in-between = partially filled star.
      const fill = Math.max(0, Math.min(1, value - (i - 1)))
      stars.push(
        <span
          key={i}
          className={`star ${editable ? 'editable' : ''}`}
          onClick={() => this.handleClick(i)}
        >
          <span className='star-bg'><FontAwesomeIcon icon={faStar} /></span>
          <span className='star-fg' style={{ width: `${fill * 100}%` }}>
            <FontAwesomeIcon icon={faStar} />
          </span>
        </span>
      )
    }
    return (
      <div className={`star-rating ${size === 'sm' ? 'sm' : ''}`}>
        <div className='stars'>{stars}</div>
        {showLabel && <span className='star-label'>{label != null ? label : `${value} / ${max}`}</span>}
      </div>
    )
  }
}

StarRating.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  editable: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['sm', 'md']),
  onChange: PropTypes.func
}

StarRating.defaultProps = {
  value: 0,
  max: 5,
  editable: false,
  showLabel: true,
  label: null,
  size: 'md'
}

export default StarRating
